import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      params: [],
      anyTypeList: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var allData, newData, k, j;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                allData = JSON.parse(data);
                newData = {};
                console.log("allData===", allData);
                _this.params = [];

                for (k in allData["unity_params"]) {
                  // if(k != "anyType"){
                  _this.params.push({
                    label: k,
                    value: allData["unity_params"][k]
                  }); // }

                }

                for (j in allData) {
                  if (j != "unity_params") {
                    newData[j] = allData[j];
                  }
                }

                _this.anyTypeList = _this.$utils.transformObject(newData);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};